import React from 'react'

// Renders the masked-answer bar with live per-character feedback.
//
// Rules:
//   1. The rendered character at each position ALWAYS comes from
//      `masked` — a "*" stays "*", a revealed letter (from paired
//      underscore markers in the model's answer) stays a letter. Space,
//      hyphen and apostrophe pass through the mask so the kid can see
//      word structure.
//   2. Coloring reflects what the kid typed at that position:
//        - typed & matches answer[i]  -> green (class `match`)
//        - typed & wrong              -> red   (class `mismatch`)
//        - not typed yet              -> neutral (class `pending`)
//      Comparison is case-insensitive.
//   3. Spaces get a special treatment: once the kid has typed past that
//      position, the space renders as an underscore ("_") so it's
//      visible whether they placed a space there. Green if they did,
//      red if they typed a non-space at that position.
//   4. Overflow (kid typed more characters than the answer has) is
//      shown as a red "?" per excess character.
//
// If `masked` is falsy we fall back to a "*" for every position of
// `answer` so the bar still renders sensibly.
export default function MaskedAnswer({ masked, answer, input }) {
  const inputStr = input || ''
  const answerStr = answer || ''
  const maskedStr = masked || '*'.repeat(answerStr.length)

  const chars = []
  for (let i = 0; i < maskedStr.length; i++) {
    const shown = maskedStr[i]
    if (i < inputStr.length) {
      const expected = answerStr[i] || ''
      const ok = inputStr[i].toLowerCase() === expected.toLowerCase()
      // Once typed past a space, render the placeholder as "_" so the
      // kid can see whether they placed a space there.
      const displayed = shown === ' ' ? '_' : shown
      chars.push(
        <span key={i} className={ok ? 'vocab-char match' : 'vocab-char mismatch'}>
          {displayed}
        </span>
      )
    } else {
      chars.push(<span key={i} className="vocab-char pending">{shown}</span>)
    }
  }
  for (let i = maskedStr.length; i < inputStr.length; i++) {
    chars.push(<span key={i} className="vocab-char mismatch">?</span>)
  }
  return <>{chars}</>
}
